import { Button, Grid } from '@mui/material'
import { Field, Form, Formik } from 'formik'
import { TextField } from 'formik-material-ui'
import { metodoPrograma } from '../../../components/api'
import AutoComplete from '../../../components/AutoComplete/AutoComplete'
import { useContext, useRef, useMemo } from 'react'
import { GlobalContext } from '../../../App'
import dayjs from 'dayjs'

const retornaPontoVenda = (u = []) => ({
  idAplicacao: u?.[0] || undefined,
  idAtendimento: u?.[1]?.[0]?.[0] || undefined,
  acAtendimento: u?.[1] || [],
  acPaciente: u?.[2] || [],
  idPaciente: u?.[2]?.[0]?.[0] || undefined,
  acLoteProduto: u?.[4] || [],
  idLoteProduto: u?.[4]?.[0]?.[0] || undefined,
  acViaAdministracao: u?.[6] || [],
  idViaAdministracao: u?.[6]?.[0]?.[0] || undefined,
  acUsuarioRegistrou: u?.[7] || [],
  idUsuarioRegistrou: u?.[7]?.[0]?.[0] || undefined,
  acMedico: u?.[8] || [],
  cdMedico: u?.[8]?.[0]?.[0] || undefined,
  dtInclusao: u?.[9] || undefined,
  dtAplicacao: u?.[10] || undefined,
  qtDose: u?.[11] || undefined,
  dsUnidadeDose: u?.[12] || undefined,
  dsLocalAplicacao: u?.[13] || undefined,
  dsObservacoes: u?.[14] || undefined,
})

const FormularioConteudo = ({
  isSubmitting,
  submitForm,
  setFieldValue,
  values,
  localAtendimento,
  voltar,
}) => {
  const searchPaciente = useMemo(
    () => ({
      idLocalAtendimento: localAtendimento[0],
      idAtendimento: values.idAtendimento,
    }),
    [localAtendimento, values.idAtendimento],
  )

  const searchLocal = useMemo(
    () => ({
      idLocalAtendimento: localAtendimento[0],
    }),
    [localAtendimento],
  )

  return (
    <Form style={{ width: '100%', padding: 0 }}>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <AutoComplete
            InputLabelProps={{ shrink: true }}
            label="Atendimento"
            metodo="buscaAtendimentoPontoVenda"
            getOptionLabel={(item) =>
              Array.isArray(item) && item.length > 0
                ? `Proposta ${item?.[0]?.[0] ?? '-'} - ${item?.[1] ?? ''}`
                : ''
            }
            value={values.acAtendimento}
            onChange={(_, v) => {
              setFieldValue('idAtendimento', v?.[0]?.[0])
              setFieldValue('acAtendimento', v)
              setFieldValue('idPaciente', v?.[5]?.[0]?.[0])
              setFieldValue('acPaciente', v?.[5])
            }}
          />
        </Grid>

        <Grid item xs={6}>
          <AutoComplete
            InputLabelProps={{ shrink: true }}
            label="Paciente"
            metodo="buscaPaciente"
            value={values.acPaciente}
            searchParams={searchPaciente}
            onChange={(_, v) => {
              setFieldValue('idPaciente', v?.[0]?.[0])
              setFieldValue('acPaciente', v)
            }}
          />
        </Grid>

        <Grid item xs={6}>
          <AutoComplete
            InputLabelProps={{ shrink: true }}
            label="Lote do Produto"
            metodo="buscaProdutoELote"
            getOptionLabel={(item) =>
              Array.isArray(item) && item.length > 0
                ? `Lote ${item?.[1]} - Nome: ${item?.[2]}`
                : ''
            }
            value={values.acLoteProduto}
            searchParams={searchLocal}
            onChange={(_, v) => {
              setFieldValue('idLoteProduto', v?.[0]?.[0])
              setFieldValue('acLoteProduto', v)
            }}
          />
        </Grid>

        <Grid item xs={6}>
          <AutoComplete
            InputLabelProps={{ shrink: true }}
            label="Aplicado por"
            metodo="buscaMedico"
            value={values.acMedico}
            searchParams={searchLocal}
            onChange={(_, v) => {
              setFieldValue('cdMedico', v?.[0]?.[0])
              setFieldValue('acMedico', v)
            }}
          />
        </Grid>

        <Grid item xs={3}>
          <AutoComplete
            InputLabelProps={{ shrink: true }}
            label="Via de Administração"
            metodo="buscaViaAdministracao"
            value={values.acViaAdministracao}
            searchParams={searchLocal}
            onChange={(_, v) => {
              setFieldValue('idViaAdministracao', v?.[0]?.[0])
              setFieldValue('acViaAdministracao', v)
            }}
          />
        </Grid>

        <Grid item xs={2}>
          <Field
            InputLabelProps={{ shrink: true }}
            component={TextField}
            name="qtDose"
            label="Dosagem"
            fullWidth
            margin="dense"
            variant="outlined"
            size="small"
          />
        </Grid>

        <Grid item xs={2}>
          <Field
            InputLabelProps={{ shrink: true }}
            component={TextField}
            name="dsUnidadeDose"
            label="Unidade de Medida"
            fullWidth
            margin="dense"
            variant="outlined"
            size="small"
          />
        </Grid>

        <Grid item xs={3}>
          <Field
            InputLabelProps={{ shrink: true }}
            component={TextField}
            name="dsLocalAplicacao"
            label="Local Aplicado"
            fullWidth
            margin="dense"
            variant="outlined"
            size="small"
          />
        </Grid>

        <Grid item xs={2}>
          <Field
            InputLabelProps={{ shrink: true }}
            component={TextField}
            name="dtAplicacao"
            label="Data Aplicação"
            type="datetime-local"
            fullWidth
            margin="dense"
            variant="outlined"
            size="small"
          />
        </Grid>
        <Grid item xs={12}>
          <Field
            InputLabelProps={{ shrink: true }}
            component={TextField}
            name="dsObservacoes"
            label="Observações"
            multiline
            minRows={3}
            maxRows={10}
            fullWidth
            margin="dense"
            variant="outlined"
            size="small"
          />
        </Grid>

        <Grid
          item
          xs={12}
          style={{ display: 'flex', flexDirection: 'row-reverse' }}
        >
          <Button
            onClick={submitForm}
            disabled={isSubmitting}
            variant="contained"
            color="primary"
            style={{ margin: '5px' }}
          >
            Salvar
          </Button>

          <Button
            onClick={voltar}
            variant="contained"
            color="secondary"
            style={{ margin: '5px' }}
          >
            Cancelar
          </Button>
        </Grid>
      </Grid>
    </Form>
  )
}

const Edicao = ({ dados, voltar }) => {
  const { localAtendimento } = useContext(GlobalContext)
  const formik = useRef(null)

  const salva = async (values) => {
    const payload = {
      ...values,
      dtAplicacao: values?.dtAplicacao
        ? dayjs(values.dtAplicacao).format('YYYY-MM-DD HH:mm:ss')
        : undefined,
    }

    const res = await metodoPrograma('salva', payload)

    if (res.status) voltar()
  }

  return (
    <Formik
      innerRef={formik}
      initialValues={retornaPontoVenda(dados)}
      onSubmit={async (values, { setSubmitting }) => {
        await salva(values)
        setSubmitting(false)
      }}
    >
      {(props) => (
        <FormularioConteudo
          {...props}
          localAtendimento={localAtendimento}
          voltar={voltar}
        />
      )}
    </Formik>
  )
}

export default Edicao
